package me.repeater64.advancedmpkeditor.gui.component

import advancedmpkeditor.composeapp.generated.resources.Res
import advancedmpkeditor.composeapp.generated.resources.*
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.DefaultAlpha
import androidx.compose.ui.graphics.Shadow
import androidx.compose.ui.unit.dp
import me.repeater64.advancedmpkeditor.backend.data_object.item.DontReplaceMinecraftItem
import me.repeater64.advancedmpkeditor.backend.data_object.item.MinecraftItem
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun MinecraftItemIcon(
    minecraftItem: MinecraftItem,
    modifier: Modifier = Modifier,
    displayDontReplaceAsAir: Boolean = false,
    alphaValue: Float? = null
) {
    Box(modifier = modifier) {

        Image(
            painter = painterResource(getItemResource(if (displayDontReplaceAsAir && minecraftItem is DontReplaceMinecraftItem) "air.png" else minecraftItem.iconFile)),
            contentDescription = minecraftItem.displayName,
            modifier = Modifier.fillMaxSize(),
            alpha = alphaValue ?: DefaultAlpha
        )
        if (minecraftItem.amount > 1) {
            Text("${minecraftItem.amount}",
            style = MaterialTheme.typography.labelSmall.copy(
                color = if (alphaValue == null) Color.White else Color.Gray,
                shadow = Shadow(
                    color = Color.Black,
                    offset = Offset(2f, 2f),
                    blurRadius = 1f
                )
            ),
            modifier = Modifier
                .align(Alignment.BottomEnd)
                .padding(2.dp)
            )
        }
    }
}

fun getItemResource(filename: String): DrawableResource {
    return when (filename) {
        "empty_helmet_slot.png" -> Res.drawable.empty_helmet_slot
        "empty_chestplate_slot.png" -> Res.drawable.empty_chestplate_slot
        "empty_leggings_slot.png" -> Res.drawable.empty_leggings_slot
        "empty_boots_slot.png" -> Res.drawable.empty_boots_slot
        "plus_icon.png" -> Res.drawable.plus_icon
        "acacia_boat.png" -> Res.drawable.acacia_boat
        "acacia_button.png" -> Res.drawable.acacia_button
        "acacia_door.png" -> Res.drawable.acacia_door
        "acacia_fence.png" -> Res.drawable.acacia_fence
        "acacia_fence_gate.png" -> Res.drawable.acacia_fence_gate
        "acacia_leaves.png" -> Res.drawable.acacia_leaves
        "acacia_log.png" -> Res.drawable.acacia_log
        "acacia_planks.png" -> Res.drawable.acacia_planks
        "acacia_pressure_plate.png" -> Res.drawable.acacia_pressure_plate
        "acacia_sapling.png" -> Res.drawable.acacia_sapling
        "acacia_sign.png" -> Res.drawable.acacia_sign
        "acacia_slab.png" -> Res.drawable.acacia_slab
        "acacia_stairs.png" -> Res.drawable.acacia_stairs
        "acacia_trapdoor.png" -> Res.drawable.acacia_trapdoor
        "acacia_wood.png" -> Res.drawable.acacia_wood
        "activator_rail.png" -> Res.drawable.activator_rail
        "air.png" -> Res.drawable.air
        "allium.png" -> Res.drawable.allium
        "ancient_debris.png" -> Res.drawable.ancient_debris
        "andesite.png" -> Res.drawable.andesite
        "andesite_slab.png" -> Res.drawable.andesite_slab
        "andesite_stairs.png" -> Res.drawable.andesite_stairs
        "andesite_wall.png" -> Res.drawable.andesite_wall
        "anvil.png" -> Res.drawable.anvil
        "apple.png" -> Res.drawable.apple
        "armor_stand.png" -> Res.drawable.armor_stand
        "arrow.png" -> Res.drawable.arrow
        "azure_bluet.png" -> Res.drawable.azure_bluet
        "baked_potato.png" -> Res.drawable.baked_potato
        "bamboo.png" -> Res.drawable.bamboo
        "barrel.png" -> Res.drawable.barrel
        "barrier.png" -> Res.drawable.barrier
        "basalt.png" -> Res.drawable.basalt
        "bat_spawn_egg.png" -> Res.drawable.bat_spawn_egg
        "beacon.png" -> Res.drawable.beacon
        "bedrock.png" -> Res.drawable.bedrock
        "bee_nest.png" -> Res.drawable.bee_nest
        "bee_spawn_egg.png" -> Res.drawable.bee_spawn_egg
        "beef.png" -> Res.drawable.beef
        "beehive.png" -> Res.drawable.beehive
        "beetroot.png" -> Res.drawable.beetroot
        "beetroot_seeds.png" -> Res.drawable.beetroot_seeds
        "beetroot_soup.png" -> Res.drawable.beetroot_soup
        "bell.png" -> Res.drawable.bell
        "birch_boat.png" -> Res.drawable.birch_boat
        "birch_button.png" -> Res.drawable.birch_button
        "birch_door.png" -> Res.drawable.birch_door
        "birch_fence.png" -> Res.drawable.birch_fence
        "birch_fence_gate.png" -> Res.drawable.birch_fence_gate
        "birch_leaves.png" -> Res.drawable.birch_leaves
        "birch_log.png" -> Res.drawable.birch_log
        "birch_planks.png" -> Res.drawable.birch_planks
        "birch_pressure_plate.png" -> Res.drawable.birch_pressure_plate
        "birch_sapling.png" -> Res.drawable.birch_sapling
        "birch_sign.png" -> Res.drawable.birch_sign
        "birch_slab.png" -> Res.drawable.birch_slab
        "birch_stairs.png" -> Res.drawable.birch_stairs
        "birch_trapdoor.png" -> Res.drawable.birch_trapdoor
        "birch_wood.png" -> Res.drawable.birch_wood
        "black_banner.png" -> Res.drawable.black_banner
        "black_bed.png" -> Res.drawable.black_bed
        "black_carpet.png" -> Res.drawable.black_carpet
        "black_concrete.png" -> Res.drawable.black_concrete
        "black_concrete_powder.png" -> Res.drawable.black_concrete_powder
        "black_dye.png" -> Res.drawable.black_dye
        "black_glazed_terracotta.png" -> Res.drawable.black_glazed_terracotta
        "black_shulker_box.png" -> Res.drawable.black_shulker_box
        "black_stained_glass.png" -> Res.drawable.black_stained_glass
        "black_stained_glass_pane.png" -> Res.drawable.black_stained_glass_pane
        "black_terracotta.png" -> Res.drawable.black_terracotta
        "black_wool.png" -> Res.drawable.black_wool
        "blackstone.png" -> Res.drawable.blackstone
        "blackstone_slab.png" -> Res.drawable.blackstone_slab
        "blackstone_stairs.png" -> Res.drawable.blackstone_stairs
        "blackstone_wall.png" -> Res.drawable.blackstone_wall
        "blast_furnace.png" -> Res.drawable.blast_furnace
        "blaze_powder.png" -> Res.drawable.blaze_powder
        "blaze_rod.png" -> Res.drawable.blaze_rod
        "blaze_spawn_egg.png" -> Res.drawable.blaze_spawn_egg
        "blue_banner.png" -> Res.drawable.blue_banner
        "blue_bed.png" -> Res.drawable.blue_bed
        "blue_carpet.png" -> Res.drawable.blue_carpet
        "blue_concrete.png" -> Res.drawable.blue_concrete
        "blue_concrete_powder.png" -> Res.drawable.blue_concrete_powder
        "blue_dye.png" -> Res.drawable.blue_dye
        "blue_glazed_terracotta.png" -> Res.drawable.blue_glazed_terracotta
        "blue_ice.png" -> Res.drawable.blue_ice
        "blue_orchid.png" -> Res.drawable.blue_orchid
        "blue_shulker_box.png" -> Res.drawable.blue_shulker_box
        "blue_stained_glass.png" -> Res.drawable.blue_stained_glass
        "blue_stained_glass_pane.png" -> Res.drawable.blue_stained_glass_pane
        "blue_terracotta.png" -> Res.drawable.blue_terracotta
        "blue_wool.png" -> Res.drawable.blue_wool
        "bone.png" -> Res.drawable.bone
        "bone_block.png" -> Res.drawable.bone_block
        "bone_meal.png" -> Res.drawable.bone_meal
        "book.png" -> Res.drawable.book
        "bookshelf.png" -> Res.drawable.bookshelf
        "bow.png" -> Res.drawable.bow
        "bowl.png" -> Res.drawable.bowl
        "brain_coral.png" -> Res.drawable.brain_coral
        "brain_coral_block.png" -> Res.drawable.brain_coral_block
        "brain_coral_fan.png" -> Res.drawable.brain_coral_fan
        "bread.png" -> Res.drawable.bread
        "brewing_stand.png" -> Res.drawable.brewing_stand
        "brick.png" -> Res.drawable.brick
        "brick_slab.png" -> Res.drawable.brick_slab
        "brick_stairs.png" -> Res.drawable.brick_stairs
        "brick_wall.png" -> Res.drawable.brick_wall
        "bricks.png" -> Res.drawable.bricks
        "brown_banner.png" -> Res.drawable.brown_banner
        "brown_bed.png" -> Res.drawable.brown_bed
        "brown_carpet.png" -> Res.drawable.brown_carpet
        "brown_concrete.png" -> Res.drawable.brown_concrete
        "brown_concrete_powder.png" -> Res.drawable.brown_concrete_powder
        "brown_dye.png" -> Res.drawable.brown_dye
        "brown_glazed_terracotta.png" -> Res.drawable.brown_glazed_terracotta
        "brown_mushroom.png" -> Res.drawable.brown_mushroom
        "brown_mushroom_block.png" -> Res.drawable.brown_mushroom_block
        "brown_shulker_box.png" -> Res.drawable.brown_shulker_box
        "brown_stained_glass.png" -> Res.drawable.brown_stained_glass
        "brown_stained_glass_pane.png" -> Res.drawable.brown_stained_glass_pane
        "brown_terracotta.png" -> Res.drawable.brown_terracotta
        "brown_wool.png" -> Res.drawable.brown_wool
        "bubble_coral.png" -> Res.drawable.bubble_coral
        "bubble_coral_block.png" -> Res.drawable.bubble_coral_block
        "bubble_coral_fan.png" -> Res.drawable.bubble_coral_fan
        "bucket.png" -> Res.drawable.bucket
        "cactus.png" -> Res.drawable.cactus
        "cake.png" -> Res.drawable.cake
        "campfire.png" -> Res.drawable.campfire
        "carrot.png" -> Res.drawable.carrot
        "carrot_on_a_stick.png" -> Res.drawable.carrot_on_a_stick
        "cartography_table.png" -> Res.drawable.cartography_table
        "carved_pumpkin.png" -> Res.drawable.carved_pumpkin
        "cat_spawn_egg.png" -> Res.drawable.cat_spawn_egg
        "cauldron.png" -> Res.drawable.cauldron
        "cave_spider_spawn_egg.png" -> Res.drawable.cave_spider_spawn_egg
        "chain.png" -> Res.drawable.chain
        "chain_command_block.png" -> Res.drawable.chain_command_block
        "chainmail_boots.png" -> Res.drawable.chainmail_boots
        "chainmail_chestplate.png" -> Res.drawable.chainmail_chestplate
        "chainmail_helmet.png" -> Res.drawable.chainmail_helmet
        "chainmail_leggings.png" -> Res.drawable.chainmail_leggings
        "charcoal.png" -> Res.drawable.charcoal
        "chest.png" -> Res.drawable.chest
        "chest_minecart.png" -> Res.drawable.chest_minecart
        "chicken.png" -> Res.drawable.chicken
        "chicken_spawn_egg.png" -> Res.drawable.chicken_spawn_egg
        "chipped_anvil.png" -> Res.drawable.chipped_anvil
        "chiseled_nether_bricks.png" -> Res.drawable.chiseled_nether_bricks
        "chiseled_polished_blackstone.png" -> Res.drawable.chiseled_polished_blackstone
        "chiseled_quartz_block.png" -> Res.drawable.chiseled_quartz_block
        "chiseled_red_sandstone.png" -> Res.drawable.chiseled_red_sandstone
        "chiseled_sandstone.png" -> Res.drawable.chiseled_sandstone
        "chiseled_stone_bricks.png" -> Res.drawable.chiseled_stone_bricks
        "chorus_flower.png" -> Res.drawable.chorus_flower
        "chorus_fruit.png" -> Res.drawable.chorus_fruit
        "chorus_plant.png" -> Res.drawable.chorus_plant
        "clay.png" -> Res.drawable.clay
        "clay_ball.png" -> Res.drawable.clay_ball
        "clock.png" -> Res.drawable.clock
        "coal.png" -> Res.drawable.coal
        "coal_block.png" -> Res.drawable.coal_block
        "coal_ore.png" -> Res.drawable.coal_ore
        "coarse_dirt.png" -> Res.drawable.coarse_dirt
        "cobblestone.png" -> Res.drawable.cobblestone
        "cobblestone_slab.png" -> Res.drawable.cobblestone_slab
        "cobblestone_stairs.png" -> Res.drawable.cobblestone_stairs
        "cobblestone_wall.png" -> Res.drawable.cobblestone_wall
        "cobweb.png" -> Res.drawable.cobweb
        "cocoa_beans.png" -> Res.drawable.cocoa_beans
        "cod.png" -> Res.drawable.cod
        "cod_bucket.png" -> Res.drawable.cod_bucket
        "cod_spawn_egg.png" -> Res.drawable.cod_spawn_egg
        "command_block.png" -> Res.drawable.command_block
        "command_block_minecart.png" -> Res.drawable.command_block_minecart
        "comparator.png" -> Res.drawable.comparator
        "compass.png" -> Res.drawable.compass
        "composter.png" -> Res.drawable.composter
        "conduit.png" -> Res.drawable.conduit
        "cooked_beef.png" -> Res.drawable.cooked_beef
        "cooked_chicken.png" -> Res.drawable.cooked_chicken
        "cooked_cod.png" -> Res.drawable.cooked_cod
        "cooked_mutton.png" -> Res.drawable.cooked_mutton
        "cooked_porkchop.png" -> Res.drawable.cooked_porkchop
        "cooked_rabbit.png" -> Res.drawable.cooked_rabbit
        "cooked_salmon.png" -> Res.drawable.cooked_salmon
        "cookie.png" -> Res.drawable.cookie
        "cornflower.png" -> Res.drawable.cornflower
        "cow_spawn_egg.png" -> Res.drawable.cow_spawn_egg
        "cracked_nether_bricks.png" -> Res.drawable.cracked_nether_bricks
        "cracked_polished_blackstone_bricks.png" -> Res.drawable.cracked_polished_blackstone_bricks
        "cracked_stone_bricks.png" -> Res.drawable.cracked_stone_bricks
        "crafting_table.png" -> Res.drawable.crafting_table
        "creeper_banner_pattern.png" -> Res.drawable.creeper_banner_pattern
        "creeper_head.png" -> Res.drawable.creeper_head
        "creeper_spawn_egg.png" -> Res.drawable.creeper_spawn_egg
        "crimson_button.png" -> Res.drawable.crimson_button
        "crimson_door.png" -> Res.drawable.crimson_door
        "crimson_fence.png" -> Res.drawable.crimson_fence
        "crimson_fence_gate.png" -> Res.drawable.crimson_fence_gate
        "crimson_fungus.png" -> Res.drawable.crimson_fungus
        "crimson_hyphae.png" -> Res.drawable.crimson_hyphae
        "crimson_nylium.png" -> Res.drawable.crimson_nylium
        "crimson_planks.png" -> Res.drawable.crimson_planks
        "crimson_pressure_plate.png" -> Res.drawable.crimson_pressure_plate
        "crimson_roots.png" -> Res.drawable.crimson_roots
        "crimson_sign.png" -> Res.drawable.crimson_sign
        "crimson_slab.png" -> Res.drawable.crimson_slab
        "crimson_stairs.png" -> Res.drawable.crimson_stairs
        "crimson_stem.png" -> Res.drawable.crimson_stem
        "crimson_trapdoor.png" -> Res.drawable.crimson_trapdoor
        "crossbow.png" -> Res.drawable.crossbow
        "crying_obsidian.png" -> Res.drawable.crying_obsidian
        "cut_red_sandstone.png" -> Res.drawable.cut_red_sandstone
        "cut_red_sandstone_slab.png" -> Res.drawable.cut_red_sandstone_slab
        "cut_sandstone.png" -> Res.drawable.cut_sandstone
        "cut_sandstone_slab.png" -> Res.drawable.cut_sandstone_slab
        "cyan_banner.png" -> Res.drawable.cyan_banner
        "cyan_bed.png" -> Res.drawable.cyan_bed
        "cyan_carpet.png" -> Res.drawable.cyan_carpet
        "cyan_concrete.png" -> Res.drawable.cyan_concrete
        "cyan_concrete_powder.png" -> Res.drawable.cyan_concrete_powder
        "cyan_dye.png" -> Res.drawable.cyan_dye
        "cyan_glazed_terracotta.png" -> Res.drawable.cyan_glazed_terracotta
        "cyan_shulker_box.png" -> Res.drawable.cyan_shulker_box
        "cyan_stained_glass.png" -> Res.drawable.cyan_stained_glass
        "cyan_stained_glass_pane.png" -> Res.drawable.cyan_stained_glass_pane
        "cyan_terracotta.png" -> Res.drawable.cyan_terracotta
        "cyan_wool.png" -> Res.drawable.cyan_wool
        "damaged_anvil.png" -> Res.drawable.damaged_anvil
        "dandelion.png" -> Res.drawable.dandelion
        "dark_oak_boat.png" -> Res.drawable.dark_oak_boat
        "dark_oak_button.png" -> Res.drawable.dark_oak_button
        "dark_oak_door.png" -> Res.drawable.dark_oak_door
        "dark_oak_fence.png" -> Res.drawable.dark_oak_fence
        "dark_oak_fence_gate.png" -> Res.drawable.dark_oak_fence_gate
        "dark_oak_leaves.png" -> Res.drawable.dark_oak_leaves
        "dark_oak_log.png" -> Res.drawable.dark_oak_log
        "dark_oak_planks.png" -> Res.drawable.dark_oak_planks
        "dark_oak_pressure_plate.png" -> Res.drawable.dark_oak_pressure_plate
        "dark_oak_sapling.png" -> Res.drawable.dark_oak_sapling
        "dark_oak_sign.png" -> Res.drawable.dark_oak_sign
        "dark_oak_slab.png" -> Res.drawable.dark_oak_slab
        "dark_oak_stairs.png" -> Res.drawable.dark_oak_stairs
        "dark_oak_trapdoor.png" -> Res.drawable.dark_oak_trapdoor
        "dark_oak_wood.png" -> Res.drawable.dark_oak_wood
        "dark_prismarine.png" -> Res.drawable.dark_prismarine
        "dark_prismarine_slab.png" -> Res.drawable.dark_prismarine_slab
        "dark_prismarine_stairs.png" -> Res.drawable.dark_prismarine_stairs
        "daylight_detector.png" -> Res.drawable.daylight_detector
        "dead_brain_coral.png" -> Res.drawable.dead_brain_coral
        "dead_brain_coral_block.png" -> Res.drawable.dead_brain_coral_block
        "dead_brain_coral_fan.png" -> Res.drawable.dead_brain_coral_fan
        "dead_bubble_coral.png" -> Res.drawable.dead_bubble_coral
        "dead_bubble_coral_block.png" -> Res.drawable.dead_bubble_coral_block
        "dead_bubble_coral_fan.png" -> Res.drawable.dead_bubble_coral_fan
        "dead_bush.png" -> Res.drawable.dead_bush
        "dead_fire_coral.png" -> Res.drawable.dead_fire_coral
        "dead_fire_coral_block.png" -> Res.drawable.dead_fire_coral_block
        "dead_fire_coral_fan.png" -> Res.drawable.dead_fire_coral_fan
        "dead_horn_coral.png" -> Res.drawable.dead_horn_coral
        "dead_horn_coral_block.png" -> Res.drawable.dead_horn_coral_block
        "dead_horn_coral_fan.png" -> Res.drawable.dead_horn_coral_fan
        "dead_tube_coral.png" -> Res.drawable.dead_tube_coral
        "dead_tube_coral_block.png" -> Res.drawable.dead_tube_coral_block
        "dead_tube_coral_fan.png" -> Res.drawable.dead_tube_coral_fan
        "debug_stick.png" -> Res.drawable.debug_stick
        "detector_rail.png" -> Res.drawable.detector_rail
        "diamond.png" -> Res.drawable.diamond
        "diamond_axe.png" -> Res.drawable.diamond_axe
        "diamond_block.png" -> Res.drawable.diamond_block
        "diamond_boots.png" -> Res.drawable.diamond_boots
        "diamond_chestplate.png" -> Res.drawable.diamond_chestplate
        "diamond_helmet.png" -> Res.drawable.diamond_helmet
        "diamond_hoe.png" -> Res.drawable.diamond_hoe
        "diamond_horse_armor.png" -> Res.drawable.diamond_horse_armor
        "diamond_leggings.png" -> Res.drawable.diamond_leggings
        "diamond_ore.png" -> Res.drawable.diamond_ore
        "diamond_pickaxe.png" -> Res.drawable.diamond_pickaxe
        "diamond_shovel.png" -> Res.drawable.diamond_shovel
        "diamond_sword.png" -> Res.drawable.diamond_sword
        "diorite.png" -> Res.drawable.diorite
        "diorite_slab.png" -> Res.drawable.diorite_slab
        "diorite_stairs.png" -> Res.drawable.diorite_stairs
        "diorite_wall.png" -> Res.drawable.diorite_wall
        "dirt.png" -> Res.drawable.dirt
        "dispenser.png" -> Res.drawable.dispenser
        "dolphin_spawn_egg.png" -> Res.drawable.dolphin_spawn_egg
        "donkey_spawn_egg.png" -> Res.drawable.donkey_spawn_egg
        "dragon_breath.png" -> Res.drawable.dragon_breath
        "dragon_egg.png" -> Res.drawable.dragon_egg
        "dragon_head.png" -> Res.drawable.dragon_head
        "dried_kelp.png" -> Res.drawable.dried_kelp
        "dried_kelp_block.png" -> Res.drawable.dried_kelp_block
        "dropper.png" -> Res.drawable.dropper
        "drowned_spawn_egg.png" -> Res.drawable.drowned_spawn_egg
        "egg.png" -> Res.drawable.egg
        "elder_guardian_spawn_egg.png" -> Res.drawable.elder_guardian_spawn_egg
        "elytra.png" -> Res.drawable.elytra
        "emerald.png" -> Res.drawable.emerald
        "emerald_block.png" -> Res.drawable.emerald_block
        "emerald_ore.png" -> Res.drawable.emerald_ore
        "enchanted_book.png" -> Res.drawable.enchanted_book
        "enchanted_golden_apple.png" -> Res.drawable.enchanted_golden_apple
        "enchanting_table.png" -> Res.drawable.enchanting_table
        "end_crystal.png" -> Res.drawable.end_crystal
        "end_portal_frame.png" -> Res.drawable.end_portal_frame
        "end_rod.png" -> Res.drawable.end_rod
        "end_stone.png" -> Res.drawable.end_stone
        "end_stone_brick_slab.png" -> Res.drawable.end_stone_brick_slab
        "end_stone_brick_stairs.png" -> Res.drawable.end_stone_brick_stairs
        "end_stone_brick_wall.png" -> Res.drawable.end_stone_brick_wall
        "end_stone_bricks.png" -> Res.drawable.end_stone_bricks
        "ender_chest.png" -> Res.drawable.ender_chest
        "ender_eye.png" -> Res.drawable.ender_eye
        "ender_pearl.png" -> Res.drawable.ender_pearl
        "enderman_spawn_egg.png" -> Res.drawable.enderman_spawn_egg
        "endermite_spawn_egg.png" -> Res.drawable.endermite_spawn_egg
        "evoker_spawn_egg.png" -> Res.drawable.evoker_spawn_egg
        "experience_bottle.png" -> Res.drawable.experience_bottle
        "farmland.png" -> Res.drawable.farmland
        "feather.png" -> Res.drawable.feather
        "fermented_spider_eye.png" -> Res.drawable.fermented_spider_eye
        "fern.png" -> Res.drawable.fern
        "filled_map.png" -> Res.drawable.filled_map
        "fire_charge.png" -> Res.drawable.fire_charge
        "fire_coral.png" -> Res.drawable.fire_coral
        "fire_coral_block.png" -> Res.drawable.fire_coral_block
        "fire_coral_fan.png" -> Res.drawable.fire_coral_fan
        "firework_rocket.png" -> Res.drawable.firework_rocket
        "firework_star.png" -> Res.drawable.firework_star
        "fishing_rod.png" -> Res.drawable.fishing_rod
        "fletching_table.png" -> Res.drawable.fletching_table
        "flint.png" -> Res.drawable.flint
        "flint_and_steel.png" -> Res.drawable.flint_and_steel
        "flower_banner_pattern.png" -> Res.drawable.flower_banner_pattern
        "flower_pot.png" -> Res.drawable.flower_pot
        "fox_spawn_egg.png" -> Res.drawable.fox_spawn_egg
        "furnace.png" -> Res.drawable.furnace
        "furnace_minecart.png" -> Res.drawable.furnace_minecart
        "ghast_spawn_egg.png" -> Res.drawable.ghast_spawn_egg
        "ghast_tear.png" -> Res.drawable.ghast_tear
        "gilded_blackstone.png" -> Res.drawable.gilded_blackstone
        "glass.png" -> Res.drawable.glass
        "glass_bottle.png" -> Res.drawable.glass_bottle
        "glass_pane.png" -> Res.drawable.glass_pane
        "glistering_melon_slice.png" -> Res.drawable.glistering_melon_slice
        "globe_banner_pattern.png" -> Res.drawable.globe_banner_pattern
        "glowstone.png" -> Res.drawable.glowstone
        "glowstone_dust.png" -> Res.drawable.glowstone_dust
        "gold_block.png" -> Res.drawable.gold_block
        "gold_ingot.png" -> Res.drawable.gold_ingot
        "gold_nugget.png" -> Res.drawable.gold_nugget
        "gold_ore.png" -> Res.drawable.gold_ore
        "golden_apple.png" -> Res.drawable.golden_apple
        "golden_axe.png" -> Res.drawable.golden_axe
        "golden_boots.png" -> Res.drawable.golden_boots
        "golden_carrot.png" -> Res.drawable.golden_carrot
        "golden_chestplate.png" -> Res.drawable.golden_chestplate
        "golden_helmet.png" -> Res.drawable.golden_helmet
        "golden_hoe.png" -> Res.drawable.golden_hoe
        "golden_horse_armor.png" -> Res.drawable.golden_horse_armor
        "golden_leggings.png" -> Res.drawable.golden_leggings
        "golden_pickaxe.png" -> Res.drawable.golden_pickaxe
        "golden_shovel.png" -> Res.drawable.golden_shovel
        "golden_sword.png" -> Res.drawable.golden_sword
        "granite.png" -> Res.drawable.granite
        "granite_slab.png" -> Res.drawable.granite_slab
        "granite_stairs.png" -> Res.drawable.granite_stairs
        "granite_wall.png" -> Res.drawable.granite_wall
        "grass.png" -> Res.drawable.grass
        "grass_block.png" -> Res.drawable.grass_block
        "grass_path.png" -> Res.drawable.grass_path
        "gravel.png" -> Res.drawable.gravel
        "gray_banner.png" -> Res.drawable.gray_banner
        "gray_bed.png" -> Res.drawable.gray_bed
        "gray_carpet.png" -> Res.drawable.gray_carpet
        "gray_concrete.png" -> Res.drawable.gray_concrete
        "gray_concrete_powder.png" -> Res.drawable.gray_concrete_powder
        "gray_dye.png" -> Res.drawable.gray_dye
        "gray_glazed_terracotta.png" -> Res.drawable.gray_glazed_terracotta
        "gray_shulker_box.png" -> Res.drawable.gray_shulker_box
        "gray_stained_glass.png" -> Res.drawable.gray_stained_glass
        "gray_stained_glass_pane.png" -> Res.drawable.gray_stained_glass_pane
        "gray_terracotta.png" -> Res.drawable.gray_terracotta
        "gray_wool.png" -> Res.drawable.gray_wool
        "green_banner.png" -> Res.drawable.green_banner
        "green_bed.png" -> Res.drawable.green_bed
        "green_carpet.png" -> Res.drawable.green_carpet
        "green_concrete.png" -> Res.drawable.green_concrete
        "green_concrete_powder.png" -> Res.drawable.green_concrete_powder
        "green_dye.png" -> Res.drawable.green_dye
        "green_glazed_terracotta.png" -> Res.drawable.green_glazed_terracotta
        "green_shulker_box.png" -> Res.drawable.green_shulker_box
        "green_stained_glass.png" -> Res.drawable.green_stained_glass
        "green_stained_glass_pane.png" -> Res.drawable.green_stained_glass_pane
        "green_terracotta.png" -> Res.drawable.green_terracotta
        "green_wool.png" -> Res.drawable.green_wool
        "grindstone.png" -> Res.drawable.grindstone
        "guardian_spawn_egg.png" -> Res.drawable.guardian_spawn_egg
        "gunpowder.png" -> Res.drawable.gunpowder
        "hay_block.png" -> Res.drawable.hay_block
        "heart_of_the_sea.png" -> Res.drawable.heart_of_the_sea
        "heavy_weighted_pressure_plate.png" -> Res.drawable.heavy_weighted_pressure_plate
        "hoglin_spawn_egg.png" -> Res.drawable.hoglin_spawn_egg
        "honey_block.png" -> Res.drawable.honey_block
        "honey_bottle.png" -> Res.drawable.honey_bottle
        "honeycomb.png" -> Res.drawable.honeycomb
        "honeycomb_block.png" -> Res.drawable.honeycomb_block
        "hopper.png" -> Res.drawable.hopper
        "hopper_minecart.png" -> Res.drawable.hopper_minecart
        "horn_coral.png" -> Res.drawable.horn_coral
        "horn_coral_block.png" -> Res.drawable.horn_coral_block
        "horn_coral_fan.png" -> Res.drawable.horn_coral_fan
        "horse_spawn_egg.png" -> Res.drawable.horse_spawn_egg
        "husk_spawn_egg.png" -> Res.drawable.husk_spawn_egg
        "ice.png" -> Res.drawable.ice
        "infested_chiseled_stone_bricks.png" -> Res.drawable.infested_chiseled_stone_bricks
        "infested_cobblestone.png" -> Res.drawable.infested_cobblestone
        "infested_cracked_stone_bricks.png" -> Res.drawable.infested_cracked_stone_bricks
        "infested_mossy_stone_bricks.png" -> Res.drawable.infested_mossy_stone_bricks
        "infested_stone.png" -> Res.drawable.infested_stone
        "infested_stone_bricks.png" -> Res.drawable.infested_stone_bricks
        "ink_sac.png" -> Res.drawable.ink_sac
        "iron_axe.png" -> Res.drawable.iron_axe
        "iron_bars.png" -> Res.drawable.iron_bars
        "iron_block.png" -> Res.drawable.iron_block
        "iron_boots.png" -> Res.drawable.iron_boots
        "iron_chestplate.png" -> Res.drawable.iron_chestplate
        "iron_door.png" -> Res.drawable.iron_door
        "iron_helmet.png" -> Res.drawable.iron_helmet
        "iron_hoe.png" -> Res.drawable.iron_hoe
        "iron_horse_armor.png" -> Res.drawable.iron_horse_armor
        "iron_ingot.png" -> Res.drawable.iron_ingot
        "iron_leggings.png" -> Res.drawable.iron_leggings
        "iron_nugget.png" -> Res.drawable.iron_nugget
        "iron_ore.png" -> Res.drawable.iron_ore
        "iron_pickaxe.png" -> Res.drawable.iron_pickaxe
        "iron_shovel.png" -> Res.drawable.iron_shovel
        "iron_sword.png" -> Res.drawable.iron_sword
        "iron_trapdoor.png" -> Res.drawable.iron_trapdoor
        "item_frame.png" -> Res.drawable.item_frame
        "jack_o_lantern.png" -> Res.drawable.jack_o_lantern
        "jigsaw.png" -> Res.drawable.jigsaw
        "jukebox.png" -> Res.drawable.jukebox
        "jungle_boat.png" -> Res.drawable.jungle_boat
        "jungle_button.png" -> Res.drawable.jungle_button
        "jungle_door.png" -> Res.drawable.jungle_door
        "jungle_fence.png" -> Res.drawable.jungle_fence
        "jungle_fence_gate.png" -> Res.drawable.jungle_fence_gate
        "jungle_leaves.png" -> Res.drawable.jungle_leaves
        "jungle_log.png" -> Res.drawable.jungle_log
        "jungle_planks.png" -> Res.drawable.jungle_planks
        "jungle_pressure_plate.png" -> Res.drawable.jungle_pressure_plate
        "jungle_sapling.png" -> Res.drawable.jungle_sapling
        "jungle_sign.png" -> Res.drawable.jungle_sign
        "jungle_slab.png" -> Res.drawable.jungle_slab
        "jungle_stairs.png" -> Res.drawable.jungle_stairs
        "jungle_trapdoor.png" -> Res.drawable.jungle_trapdoor
        "jungle_wood.png" -> Res.drawable.jungle_wood
        "kelp.png" -> Res.drawable.kelp
        "knowledge_book.png" -> Res.drawable.knowledge_book
        "ladder.png" -> Res.drawable.ladder
        "lantern.png" -> Res.drawable.lantern
        "lapis_block.png" -> Res.drawable.lapis_block
        "lapis_lazuli.png" -> Res.drawable.lapis_lazuli
        "lapis_ore.png" -> Res.drawable.lapis_ore
        "large_fern.png" -> Res.drawable.large_fern
        "lava_bucket.png" -> Res.drawable.lava_bucket
        "lead.png" -> Res.drawable.lead
        "leather.png" -> Res.drawable.leather
        "leather_boots.png" -> Res.drawable.leather_boots
        "leather_chestplate.png" -> Res.drawable.leather_chestplate
        "leather_helmet.png" -> Res.drawable.leather_helmet
        "leather_horse_armor.png" -> Res.drawable.leather_horse_armor
        "leather_leggings.png" -> Res.drawable.leather_leggings
        "lectern.png" -> Res.drawable.lectern
        "lever.png" -> Res.drawable.lever
        "light_blue_banner.png" -> Res.drawable.light_blue_banner
        "light_blue_bed.png" -> Res.drawable.light_blue_bed
        "light_blue_carpet.png" -> Res.drawable.light_blue_carpet
        "light_blue_concrete.png" -> Res.drawable.light_blue_concrete
        "light_blue_concrete_powder.png" -> Res.drawable.light_blue_concrete_powder
        "light_blue_dye.png" -> Res.drawable.light_blue_dye
        "light_blue_glazed_terracotta.png" -> Res.drawable.light_blue_glazed_terracotta
        "light_blue_shulker_box.png" -> Res.drawable.light_blue_shulker_box
        "light_blue_stained_glass.png" -> Res.drawable.light_blue_stained_glass
        "light_blue_stained_glass_pane.png" -> Res.drawable.light_blue_stained_glass_pane
        "light_blue_terracotta.png" -> Res.drawable.light_blue_terracotta
        "light_blue_wool.png" -> Res.drawable.light_blue_wool
        "light_gray_banner.png" -> Res.drawable.light_gray_banner
        "light_gray_bed.png" -> Res.drawable.light_gray_bed
        "light_gray_carpet.png" -> Res.drawable.light_gray_carpet
        "light_gray_concrete.png" -> Res.drawable.light_gray_concrete
        "light_gray_concrete_powder.png" -> Res.drawable.light_gray_concrete_powder
        "light_gray_dye.png" -> Res.drawable.light_gray_dye
        "light_gray_glazed_terracotta.png" -> Res.drawable.light_gray_glazed_terracotta
        "light_gray_shulker_box.png" -> Res.drawable.light_gray_shulker_box
        "light_gray_stained_glass.png" -> Res.drawable.light_gray_stained_glass
        "light_gray_stained_glass_pane.png" -> Res.drawable.light_gray_stained_glass_pane
        "light_gray_terracotta.png" -> Res.drawable.light_gray_terracotta
        "light_gray_wool.png" -> Res.drawable.light_gray_wool
        "light_weighted_pressure_plate.png" -> Res.drawable.light_weighted_pressure_plate
        "lilac.png" -> Res.drawable.lilac
        "lily_of_the_valley.png" -> Res.drawable.lily_of_the_valley
        "lily_pad.png" -> Res.drawable.lily_pad
        "lime_banner.png" -> Res.drawable.lime_banner
        "lime_bed.png" -> Res.drawable.lime_bed
        "lime_carpet.png" -> Res.drawable.lime_carpet
        "lime_concrete.png" -> Res.drawable.lime_concrete
        "lime_concrete_powder.png" -> Res.drawable.lime_concrete_powder
        "lime_dye.png" -> Res.drawable.lime_dye
        "lime_glazed_terracotta.png" -> Res.drawable.lime_glazed_terracotta
        "lime_shulker_box.png" -> Res.drawable.lime_shulker_box
        "lime_stained_glass.png" -> Res.drawable.lime_stained_glass
        "lime_stained_glass_pane.png" -> Res.drawable.lime_stained_glass_pane
        "lime_terracotta.png" -> Res.drawable.lime_terracotta
        "lime_wool.png" -> Res.drawable.lime_wool
        "lingering_potion.png" -> Res.drawable.lingering_potion
        "llama_spawn_egg.png" -> Res.drawable.llama_spawn_egg
        "lodestone.png" -> Res.drawable.lodestone
        "loom.png" -> Res.drawable.loom
        "magenta_banner.png" -> Res.drawable.magenta_banner
        "magenta_bed.png" -> Res.drawable.magenta_bed
        "magenta_carpet.png" -> Res.drawable.magenta_carpet
        "magenta_concrete.png" -> Res.drawable.magenta_concrete
        "magenta_concrete_powder.png" -> Res.drawable.magenta_concrete_powder
        "magenta_dye.png" -> Res.drawable.magenta_dye
        "magenta_glazed_terracotta.png" -> Res.drawable.magenta_glazed_terracotta
        "magenta_shulker_box.png" -> Res.drawable.magenta_shulker_box
        "magenta_stained_glass.png" -> Res.drawable.magenta_stained_glass
        "magenta_stained_glass_pane.png" -> Res.drawable.magenta_stained_glass_pane
        "magenta_terracotta.png" -> Res.drawable.magenta_terracotta
        "magenta_wool.png" -> Res.drawable.magenta_wool
        "magma_block.png" -> Res.drawable.magma_block
        "magma_cream.png" -> Res.drawable.magma_cream
        "magma_cube_spawn_egg.png" -> Res.drawable.magma_cube_spawn_egg
        "map.png" -> Res.drawable.map
        "melon.png" -> Res.drawable.melon
        "melon_seeds.png" -> Res.drawable.melon_seeds
        "melon_slice.png" -> Res.drawable.melon_slice
        "milk_bucket.png" -> Res.drawable.milk_bucket
        "minecart.png" -> Res.drawable.minecart
        "mojang_banner_pattern.png" -> Res.drawable.mojang_banner_pattern
        "mooshroom_spawn_egg.png" -> Res.drawable.mooshroom_spawn_egg
        "mossy_cobblestone.png" -> Res.drawable.mossy_cobblestone
        "mossy_cobblestone_slab.png" -> Res.drawable.mossy_cobblestone_slab
        "mossy_cobblestone_stairs.png" -> Res.drawable.mossy_cobblestone_stairs
        "mossy_cobblestone_wall.png" -> Res.drawable.mossy_cobblestone_wall
        "mossy_stone_brick_slab.png" -> Res.drawable.mossy_stone_brick_slab
        "mossy_stone_brick_stairs.png" -> Res.drawable.mossy_stone_brick_stairs
        "mossy_stone_brick_wall.png" -> Res.drawable.mossy_stone_brick_wall
        "mossy_stone_bricks.png" -> Res.drawable.mossy_stone_bricks
        "mule_spawn_egg.png" -> Res.drawable.mule_spawn_egg
        "mushroom_stem.png" -> Res.drawable.mushroom_stem
        "mushroom_stew.png" -> Res.drawable.mushroom_stew
        "music_disc_11.png" -> Res.drawable.music_disc_11
        "music_disc_13.png" -> Res.drawable.music_disc_13
        "music_disc_blocks.png" -> Res.drawable.music_disc_blocks
        "music_disc_cat.png" -> Res.drawable.music_disc_cat
        "music_disc_chirp.png" -> Res.drawable.music_disc_chirp
        "music_disc_far.png" -> Res.drawable.music_disc_far
        "music_disc_mall.png" -> Res.drawable.music_disc_mall
        "music_disc_mellohi.png" -> Res.drawable.music_disc_mellohi
        "music_disc_pigstep.png" -> Res.drawable.music_disc_pigstep
        "music_disc_stal.png" -> Res.drawable.music_disc_stal
        "music_disc_strad.png" -> Res.drawable.music_disc_strad
        "music_disc_wait.png" -> Res.drawable.music_disc_wait
        "music_disc_ward.png" -> Res.drawable.music_disc_ward
        "mutton.png" -> Res.drawable.mutton
        "mycelium.png" -> Res.drawable.mycelium
        "name_tag.png" -> Res.drawable.name_tag
        "nautilus_shell.png" -> Res.drawable.nautilus_shell
        "nether_brick.png" -> Res.drawable.nether_brick
        "nether_brick_fence.png" -> Res.drawable.nether_brick_fence
        "nether_brick_slab.png" -> Res.drawable.nether_brick_slab
        "nether_brick_stairs.png" -> Res.drawable.nether_brick_stairs
        "nether_brick_wall.png" -> Res.drawable.nether_brick_wall
        "nether_bricks.png" -> Res.drawable.nether_bricks
        "nether_gold_ore.png" -> Res.drawable.nether_gold_ore
        "nether_quartz_ore.png" -> Res.drawable.nether_quartz_ore
        "nether_sprouts.png" -> Res.drawable.nether_sprouts
        "nether_star.png" -> Res.drawable.nether_star
        "nether_wart.png" -> Res.drawable.nether_wart
        "nether_wart_block.png" -> Res.drawable.nether_wart_block
        "netherite_axe.png" -> Res.drawable.netherite_axe
        "netherite_block.png" -> Res.drawable.netherite_block
        "netherite_boots.png" -> Res.drawable.netherite_boots
        "netherite_chestplate.png" -> Res.drawable.netherite_chestplate
        "netherite_helmet.png" -> Res.drawable.netherite_helmet
        "netherite_hoe.png" -> Res.drawable.netherite_hoe
        "netherite_ingot.png" -> Res.drawable.netherite_ingot
        "netherite_leggings.png" -> Res.drawable.netherite_leggings
        "netherite_pickaxe.png" -> Res.drawable.netherite_pickaxe
        "netherite_scrap.png" -> Res.drawable.netherite_scrap
        "netherite_shovel.png" -> Res.drawable.netherite_shovel
        "netherite_sword.png" -> Res.drawable.netherite_sword
        "netherrack.png" -> Res.drawable.netherrack
        "note_block.png" -> Res.drawable.note_block
        "oak_boat.png" -> Res.drawable.oak_boat
        "oak_button.png" -> Res.drawable.oak_button
        "oak_door.png" -> Res.drawable.oak_door
        "oak_fence.png" -> Res.drawable.oak_fence
        "oak_fence_gate.png" -> Res.drawable.oak_fence_gate
        "oak_leaves.png" -> Res.drawable.oak_leaves
        "oak_log.png" -> Res.drawable.oak_log
        "oak_planks.png" -> Res.drawable.oak_planks
        "oak_pressure_plate.png" -> Res.drawable.oak_pressure_plate
        "oak_sapling.png" -> Res.drawable.oak_sapling
        "oak_sign.png" -> Res.drawable.oak_sign
        "oak_slab.png" -> Res.drawable.oak_slab
        "oak_stairs.png" -> Res.drawable.oak_stairs
        "oak_trapdoor.png" -> Res.drawable.oak_trapdoor
        "oak_wood.png" -> Res.drawable.oak_wood
        "observer.png" -> Res.drawable.observer
        "obsidian.png" -> Res.drawable.obsidian
        "ocelot_spawn_egg.png" -> Res.drawable.ocelot_spawn_egg
        "orange_banner.png" -> Res.drawable.orange_banner
        "orange_bed.png" -> Res.drawable.orange_bed
        "orange_carpet.png" -> Res.drawable.orange_carpet
        "orange_concrete.png" -> Res.drawable.orange_concrete
        "orange_concrete_powder.png" -> Res.drawable.orange_concrete_powder
        "orange_dye.png" -> Res.drawable.orange_dye
        "orange_glazed_terracotta.png" -> Res.drawable.orange_glazed_terracotta
        "orange_shulker_box.png" -> Res.drawable.orange_shulker_box
        "orange_stained_glass.png" -> Res.drawable.orange_stained_glass
        "orange_stained_glass_pane.png" -> Res.drawable.orange_stained_glass_pane
        "orange_terracotta.png" -> Res.drawable.orange_terracotta
        "orange_tulip.png" -> Res.drawable.orange_tulip
        "orange_wool.png" -> Res.drawable.orange_wool
        "oxeye_daisy.png" -> Res.drawable.oxeye_daisy
        "packed_ice.png" -> Res.drawable.packed_ice
        "painting.png" -> Res.drawable.painting
        "panda_spawn_egg.png" -> Res.drawable.panda_spawn_egg
        "paper.png" -> Res.drawable.paper
        "parrot_spawn_egg.png" -> Res.drawable.parrot_spawn_egg
        "peony.png" -> Res.drawable.peony
        "petrified_oak_slab.png" -> Res.drawable.petrified_oak_slab
        "phantom_membrane.png" -> Res.drawable.phantom_membrane
        "phantom_spawn_egg.png" -> Res.drawable.phantom_spawn_egg
        "pig_spawn_egg.png" -> Res.drawable.pig_spawn_egg
        "piglin_banner_pattern.png" -> Res.drawable.piglin_banner_pattern
        "piglin_brute_spawn_egg.png" -> Res.drawable.piglin_brute_spawn_egg
        "piglin_spawn_egg.png" -> Res.drawable.piglin_spawn_egg
        "pillager_spawn_egg.png" -> Res.drawable.pillager_spawn_egg
        "pink_banner.png" -> Res.drawable.pink_banner
        "pink_bed.png" -> Res.drawable.pink_bed
        "pink_carpet.png" -> Res.drawable.pink_carpet
        "pink_concrete.png" -> Res.drawable.pink_concrete
        "pink_concrete_powder.png" -> Res.drawable.pink_concrete_powder
        "pink_dye.png" -> Res.drawable.pink_dye
        "pink_glazed_terracotta.png" -> Res.drawable.pink_glazed_terracotta
        "pink_shulker_box.png" -> Res.drawable.pink_shulker_box
        "pink_stained_glass.png" -> Res.drawable.pink_stained_glass
        "pink_stained_glass_pane.png" -> Res.drawable.pink_stained_glass_pane
        "pink_terracotta.png" -> Res.drawable.pink_terracotta
        "pink_tulip.png" -> Res.drawable.pink_tulip
        "pink_wool.png" -> Res.drawable.pink_wool
        "piston.png" -> Res.drawable.piston
        "player_head.png" -> Res.drawable.player_head
        "podzol.png" -> Res.drawable.podzol
        "poisonous_potato.png" -> Res.drawable.poisonous_potato
        "polar_bear_spawn_egg.png" -> Res.drawable.polar_bear_spawn_egg
        "polished_andesite.png" -> Res.drawable.polished_andesite
        "polished_andesite_slab.png" -> Res.drawable.polished_andesite_slab
        "polished_andesite_stairs.png" -> Res.drawable.polished_andesite_stairs
        "polished_basalt.png" -> Res.drawable.polished_basalt
        "polished_blackstone.png" -> Res.drawable.polished_blackstone
        "polished_blackstone_brick_slab.png" -> Res.drawable.polished_blackstone_brick_slab
        "polished_blackstone_brick_stairs.png" -> Res.drawable.polished_blackstone_brick_stairs
        "polished_blackstone_brick_wall.png" -> Res.drawable.polished_blackstone_brick_wall
        "polished_blackstone_bricks.png" -> Res.drawable.polished_blackstone_bricks
        "polished_blackstone_button.png" -> Res.drawable.polished_blackstone_button
        "polished_blackstone_pressure_plate.png" -> Res.drawable.polished_blackstone_pressure_plate
        "polished_blackstone_slab.png" -> Res.drawable.polished_blackstone_slab
        "polished_blackstone_stairs.png" -> Res.drawable.polished_blackstone_stairs
        "polished_blackstone_wall.png" -> Res.drawable.polished_blackstone_wall
        "polished_diorite.png" -> Res.drawable.polished_diorite
        "polished_diorite_slab.png" -> Res.drawable.polished_diorite_slab
        "polished_diorite_stairs.png" -> Res.drawable.polished_diorite_stairs
        "polished_granite.png" -> Res.drawable.polished_granite
        "polished_granite_slab.png" -> Res.drawable.polished_granite_slab
        "polished_granite_stairs.png" -> Res.drawable.polished_granite_stairs
        "popped_chorus_fruit.png" -> Res.drawable.popped_chorus_fruit
        "poppy.png" -> Res.drawable.poppy
        "porkchop.png" -> Res.drawable.porkchop
        "potato.png" -> Res.drawable.potato
        "potion.png" -> Res.drawable.potion
        "powered_rail.png" -> Res.drawable.powered_rail
        "prismarine.png" -> Res.drawable.prismarine
        "prismarine_brick_slab.png" -> Res.drawable.prismarine_brick_slab
        "prismarine_brick_stairs.png" -> Res.drawable.prismarine_brick_stairs
        "prismarine_bricks.png" -> Res.drawable.prismarine_bricks
        "prismarine_crystals.png" -> Res.drawable.prismarine_crystals
        "prismarine_shard.png" -> Res.drawable.prismarine_shard
        "prismarine_slab.png" -> Res.drawable.prismarine_slab
        "prismarine_stairs.png" -> Res.drawable.prismarine_stairs
        "prismarine_wall.png" -> Res.drawable.prismarine_wall
        "pufferfish.png" -> Res.drawable.pufferfish
        "pufferfish_bucket.png" -> Res.drawable.pufferfish_bucket
        "pufferfish_spawn_egg.png" -> Res.drawable.pufferfish_spawn_egg
        "pumpkin.png" -> Res.drawable.pumpkin
        "pumpkin_pie.png" -> Res.drawable.pumpkin_pie
        "pumpkin_seeds.png" -> Res.drawable.pumpkin_seeds
        "purple_banner.png" -> Res.drawable.purple_banner
        "purple_bed.png" -> Res.drawable.purple_bed
        "purple_carpet.png" -> Res.drawable.purple_carpet
        "purple_concrete.png" -> Res.drawable.purple_concrete
        "purple_concrete_powder.png" -> Res.drawable.purple_concrete_powder
        "purple_dye.png" -> Res.drawable.purple_dye
        "purple_glazed_terracotta.png" -> Res.drawable.purple_glazed_terracotta
        "purple_shulker_box.png" -> Res.drawable.purple_shulker_box
        "purple_stained_glass.png" -> Res.drawable.purple_stained_glass
        "purple_stained_glass_pane.png" -> Res.drawable.purple_stained_glass_pane
        "purple_terracotta.png" -> Res.drawable.purple_terracotta
        "purple_wool.png" -> Res.drawable.purple_wool
        "purpur_block.png" -> Res.drawable.purpur_block
        "purpur_pillar.png" -> Res.drawable.purpur_pillar
        "purpur_slab.png" -> Res.drawable.purpur_slab
        "purpur_stairs.png" -> Res.drawable.purpur_stairs
        "quartz.png" -> Res.drawable.quartz
        "quartz_block.png" -> Res.drawable.quartz_block
        "quartz_bricks.png" -> Res.drawable.quartz_bricks
        "quartz_pillar.png" -> Res.drawable.quartz_pillar
        "quartz_slab.png" -> Res.drawable.quartz_slab
        "quartz_stairs.png" -> Res.drawable.quartz_stairs
        "rabbit.png" -> Res.drawable.rabbit
        "rabbit_foot.png" -> Res.drawable.rabbit_foot
        "rabbit_hide.png" -> Res.drawable.rabbit_hide
        "rabbit_spawn_egg.png" -> Res.drawable.rabbit_spawn_egg
        "rabbit_stew.png" -> Res.drawable.rabbit_stew
        "rail.png" -> Res.drawable.rail
        "ravager_spawn_egg.png" -> Res.drawable.ravager_spawn_egg
        "red_banner.png" -> Res.drawable.red_banner
        "red_bed.png" -> Res.drawable.red_bed
        "red_carpet.png" -> Res.drawable.red_carpet
        "red_concrete.png" -> Res.drawable.red_concrete
        "red_concrete_powder.png" -> Res.drawable.red_concrete_powder
        "red_dye.png" -> Res.drawable.red_dye
        "red_glazed_terracotta.png" -> Res.drawable.red_glazed_terracotta
        "red_mushroom.png" -> Res.drawable.red_mushroom
        "red_mushroom_block.png" -> Res.drawable.red_mushroom_block
        "red_nether_brick_slab.png" -> Res.drawable.red_nether_brick_slab
        "red_nether_brick_stairs.png" -> Res.drawable.red_nether_brick_stairs
        "red_nether_brick_wall.png" -> Res.drawable.red_nether_brick_wall
        "red_nether_bricks.png" -> Res.drawable.red_nether_bricks
        "red_sand.png" -> Res.drawable.red_sand
        "red_sandstone.png" -> Res.drawable.red_sandstone
        "red_sandstone_slab.png" -> Res.drawable.red_sandstone_slab
        "red_sandstone_stairs.png" -> Res.drawable.red_sandstone_stairs
        "red_sandstone_wall.png" -> Res.drawable.red_sandstone_wall
        "red_shulker_box.png" -> Res.drawable.red_shulker_box
        "red_stained_glass.png" -> Res.drawable.red_stained_glass
        "red_stained_glass_pane.png" -> Res.drawable.red_stained_glass_pane
        "red_terracotta.png" -> Res.drawable.red_terracotta
        "red_tulip.png" -> Res.drawable.red_tulip
        "red_wool.png" -> Res.drawable.red_wool
        "redstone.png" -> Res.drawable.redstone
        "redstone_block.png" -> Res.drawable.redstone_block
        "redstone_lamp.png" -> Res.drawable.redstone_lamp
        "redstone_ore.png" -> Res.drawable.redstone_ore
        "redstone_torch.png" -> Res.drawable.redstone_torch
        "repeater.png" -> Res.drawable.repeater
        "repeating_command_block.png" -> Res.drawable.repeating_command_block
        "respawn_anchor.png" -> Res.drawable.respawn_anchor
        "rose_bush.png" -> Res.drawable.rose_bush
        "rotten_flesh.png" -> Res.drawable.rotten_flesh
        "saddle.png" -> Res.drawable.saddle
        "salmon.png" -> Res.drawable.salmon
        "salmon_bucket.png" -> Res.drawable.salmon_bucket
        "salmon_spawn_egg.png" -> Res.drawable.salmon_spawn_egg
        "sand.png" -> Res.drawable.sand
        "sandstone.png" -> Res.drawable.sandstone
        "sandstone_slab.png" -> Res.drawable.sandstone_slab
        "sandstone_stairs.png" -> Res.drawable.sandstone_stairs
        "sandstone_wall.png" -> Res.drawable.sandstone_wall
        "scaffolding.png" -> Res.drawable.scaffolding
        "scute.png" -> Res.drawable.scute
        "sea_lantern.png" -> Res.drawable.sea_lantern
        "sea_pickle.png" -> Res.drawable.sea_pickle
        "seagrass.png" -> Res.drawable.seagrass
        "shears.png" -> Res.drawable.shears
        "sheep_spawn_egg.png" -> Res.drawable.sheep_spawn_egg
        "shield.png" -> Res.drawable.shield
        "shroomlight.png" -> Res.drawable.shroomlight
        "shulker_box.png" -> Res.drawable.shulker_box
        "shulker_shell.png" -> Res.drawable.shulker_shell
        "shulker_spawn_egg.png" -> Res.drawable.shulker_spawn_egg
        "silverfish_spawn_egg.png" -> Res.drawable.silverfish_spawn_egg
        "skeleton_horse_spawn_egg.png" -> Res.drawable.skeleton_horse_spawn_egg
        "skeleton_skull.png" -> Res.drawable.skeleton_skull
        "skeleton_spawn_egg.png" -> Res.drawable.skeleton_spawn_egg
        "skull_banner_pattern.png" -> Res.drawable.skull_banner_pattern
        "slime_ball.png" -> Res.drawable.slime_ball
        "slime_block.png" -> Res.drawable.slime_block
        "slime_spawn_egg.png" -> Res.drawable.slime_spawn_egg
        "smithing_table.png" -> Res.drawable.smithing_table
        "smoker.png" -> Res.drawable.smoker
        "smooth_quartz.png" -> Res.drawable.smooth_quartz
        "smooth_quartz_slab.png" -> Res.drawable.smooth_quartz_slab
        "smooth_quartz_stairs.png" -> Res.drawable.smooth_quartz_stairs
        "smooth_red_sandstone.png" -> Res.drawable.smooth_red_sandstone
        "smooth_red_sandstone_slab.png" -> Res.drawable.smooth_red_sandstone_slab
        "smooth_red_sandstone_stairs.png" -> Res.drawable.smooth_red_sandstone_stairs
        "smooth_sandstone.png" -> Res.drawable.smooth_sandstone
        "smooth_sandstone_slab.png" -> Res.drawable.smooth_sandstone_slab
        "smooth_sandstone_stairs.png" -> Res.drawable.smooth_sandstone_stairs
        "smooth_stone.png" -> Res.drawable.smooth_stone
        "smooth_stone_slab.png" -> Res.drawable.smooth_stone_slab
        "snow.png" -> Res.drawable.snow
        "snow_block.png" -> Res.drawable.snow_block
        "snowball.png" -> Res.drawable.snowball
        "soul_campfire.png" -> Res.drawable.soul_campfire
        "soul_lantern.png" -> Res.drawable.soul_lantern
        "soul_sand.png" -> Res.drawable.soul_sand
        "soul_soil.png" -> Res.drawable.soul_soil
        "soul_torch.png" -> Res.drawable.soul_torch
        "spawner.png" -> Res.drawable.spawner
        "spectral_arrow.png" -> Res.drawable.spectral_arrow
        "spider_eye.png" -> Res.drawable.spider_eye
        "spider_spawn_egg.png" -> Res.drawable.spider_spawn_egg
        "splash_potion.png" -> Res.drawable.splash_potion
        "sponge.png" -> Res.drawable.sponge
        "spruce_boat.png" -> Res.drawable.spruce_boat
        "spruce_button.png" -> Res.drawable.spruce_button
        "spruce_door.png" -> Res.drawable.spruce_door
        "spruce_fence.png" -> Res.drawable.spruce_fence
        "spruce_fence_gate.png" -> Res.drawable.spruce_fence_gate
        "spruce_leaves.png" -> Res.drawable.spruce_leaves
        "spruce_log.png" -> Res.drawable.spruce_log
        "spruce_planks.png" -> Res.drawable.spruce_planks
        "spruce_pressure_plate.png" -> Res.drawable.spruce_pressure_plate
        "spruce_sapling.png" -> Res.drawable.spruce_sapling
        "spruce_sign.png" -> Res.drawable.spruce_sign
        "spruce_slab.png" -> Res.drawable.spruce_slab
        "spruce_stairs.png" -> Res.drawable.spruce_stairs
        "spruce_trapdoor.png" -> Res.drawable.spruce_trapdoor
        "spruce_wood.png" -> Res.drawable.spruce_wood
        "squid_spawn_egg.png" -> Res.drawable.squid_spawn_egg
        "stick.png" -> Res.drawable.stick
        "sticky_piston.png" -> Res.drawable.sticky_piston
        "stone.png" -> Res.drawable.stone
        "stone_axe.png" -> Res.drawable.stone_axe
        "stone_brick_slab.png" -> Res.drawable.stone_brick_slab
        "stone_brick_stairs.png" -> Res.drawable.stone_brick_stairs
        "stone_brick_wall.png" -> Res.drawable.stone_brick_wall
        "stone_bricks.png" -> Res.drawable.stone_bricks
        "stone_button.png" -> Res.drawable.stone_button
        "stone_hoe.png" -> Res.drawable.stone_hoe
        "stone_pickaxe.png" -> Res.drawable.stone_pickaxe
        "stone_pressure_plate.png" -> Res.drawable.stone_pressure_plate
        "stone_shovel.png" -> Res.drawable.stone_shovel
        "stone_slab.png" -> Res.drawable.stone_slab
        "stone_stairs.png" -> Res.drawable.stone_stairs
        "stone_sword.png" -> Res.drawable.stone_sword
        "stonecutter.png" -> Res.drawable.stonecutter
        "stray_spawn_egg.png" -> Res.drawable.stray_spawn_egg
        "strider_spawn_egg.png" -> Res.drawable.strider_spawn_egg
        "string.png" -> Res.drawable.string
        "stripped_acacia_log.png" -> Res.drawable.stripped_acacia_log
        "stripped_acacia_wood.png" -> Res.drawable.stripped_acacia_wood
        "stripped_birch_log.png" -> Res.drawable.stripped_birch_log
        "stripped_birch_wood.png" -> Res.drawable.stripped_birch_wood
        "stripped_crimson_hyphae.png" -> Res.drawable.stripped_crimson_hyphae
        "stripped_crimson_stem.png" -> Res.drawable.stripped_crimson_stem
        "stripped_dark_oak_log.png" -> Res.drawable.stripped_dark_oak_log
        "stripped_dark_oak_wood.png" -> Res.drawable.stripped_dark_oak_wood
        "stripped_jungle_log.png" -> Res.drawable.stripped_jungle_log
        "stripped_jungle_wood.png" -> Res.drawable.stripped_jungle_wood
        "stripped_oak_log.png" -> Res.drawable.stripped_oak_log
        "stripped_oak_wood.png" -> Res.drawable.stripped_oak_wood
        "stripped_spruce_log.png" -> Res.drawable.stripped_spruce_log
        "stripped_spruce_wood.png" -> Res.drawable.stripped_spruce_wood
        "stripped_warped_hyphae.png" -> Res.drawable.stripped_warped_hyphae
        "stripped_warped_stem.png" -> Res.drawable.stripped_warped_stem
        "structure_block.png" -> Res.drawable.structure_block
        "structure_void.png" -> Res.drawable.structure_void
        "sugar.png" -> Res.drawable.sugar
        "sugar_cane.png" -> Res.drawable.sugar_cane
        "sunflower.png" -> Res.drawable.sunflower
        "suspicious_stew.png" -> Res.drawable.suspicious_stew
        "sweet_berries.png" -> Res.drawable.sweet_berries
        "tall_grass.png" -> Res.drawable.tall_grass
        "target.png" -> Res.drawable.target
        "terracotta.png" -> Res.drawable.terracotta
        "tipped_arrow.png" -> Res.drawable.tipped_arrow
        "tnt.png" -> Res.drawable.tnt
        "tnt_minecart.png" -> Res.drawable.tnt_minecart
        "torch.png" -> Res.drawable.torch
        "totem_of_undying.png" -> Res.drawable.totem_of_undying
        "trader_llama_spawn_egg.png" -> Res.drawable.trader_llama_spawn_egg
        "trapped_chest.png" -> Res.drawable.trapped_chest
        "trident.png" -> Res.drawable.trident
        "tripwire_hook.png" -> Res.drawable.tripwire_hook
        "tropical_fish.png" -> Res.drawable.tropical_fish
        "tropical_fish_bucket.png" -> Res.drawable.tropical_fish_bucket
        "tropical_fish_spawn_egg.png" -> Res.drawable.tropical_fish_spawn_egg
        "tube_coral.png" -> Res.drawable.tube_coral
        "tube_coral_block.png" -> Res.drawable.tube_coral_block
        "tube_coral_fan.png" -> Res.drawable.tube_coral_fan
        "turtle_egg.png" -> Res.drawable.turtle_egg
        "turtle_helmet.png" -> Res.drawable.turtle_helmet
        "turtle_spawn_egg.png" -> Res.drawable.turtle_spawn_egg
        "vex_spawn_egg.png" -> Res.drawable.vex_spawn_egg
        "villager_spawn_egg.png" -> Res.drawable.villager_spawn_egg
        "vindicator_spawn_egg.png" -> Res.drawable.vindicator_spawn_egg
        "vine.png" -> Res.drawable.vine
        "wandering_trader_spawn_egg.png" -> Res.drawable.wandering_trader_spawn_egg
        "warped_button.png" -> Res.drawable.warped_button
        "warped_door.png" -> Res.drawable.warped_door
        "warped_fence.png" -> Res.drawable.warped_fence
        "warped_fence_gate.png" -> Res.drawable.warped_fence_gate
        "warped_fungus.png" -> Res.drawable.warped_fungus
        "warped_fungus_on_a_stick.png" -> Res.drawable.warped_fungus_on_a_stick
        "warped_hyphae.png" -> Res.drawable.warped_hyphae
        "warped_nylium.png" -> Res.drawable.warped_nylium
        "warped_planks.png" -> Res.drawable.warped_planks
        "warped_pressure_plate.png" -> Res.drawable.warped_pressure_plate
        "warped_roots.png" -> Res.drawable.warped_roots
        "warped_sign.png" -> Res.drawable.warped_sign
        "warped_slab.png" -> Res.drawable.warped_slab
        "warped_stairs.png" -> Res.drawable.warped_stairs
        "warped_stem.png" -> Res.drawable.warped_stem
        "warped_trapdoor.png" -> Res.drawable.warped_trapdoor
        "warped_wart_block.png" -> Res.drawable.warped_wart_block
        "water_bucket.png" -> Res.drawable.water_bucket
        "weeping_vines.png" -> Res.drawable.weeping_vines
        "wet_sponge.png" -> Res.drawable.wet_sponge
        "wheat.png" -> Res.drawable.wheat
        "wheat_seeds.png" -> Res.drawable.wheat_seeds
        "white_banner.png" -> Res.drawable.white_banner
        "white_bed.png" -> Res.drawable.white_bed
        "white_carpet.png" -> Res.drawable.white_carpet
        "white_concrete.png" -> Res.drawable.white_concrete
        "white_concrete_powder.png" -> Res.drawable.white_concrete_powder
        "white_dye.png" -> Res.drawable.white_dye
        "white_glazed_terracotta.png" -> Res.drawable.white_glazed_terracotta
        "white_shulker_box.png" -> Res.drawable.white_shulker_box
        "white_stained_glass.png" -> Res.drawable.white_stained_glass
        "white_stained_glass_pane.png" -> Res.drawable.white_stained_glass_pane
        "white_terracotta.png" -> Res.drawable.white_terracotta
        "white_tulip.png" -> Res.drawable.white_tulip
        "white_wool.png" -> Res.drawable.white_wool
        "witch_spawn_egg.png" -> Res.drawable.witch_spawn_egg
        "wither_rose.png" -> Res.drawable.wither_rose
        "wither_skeleton_skull.png" -> Res.drawable.wither_skeleton_skull
        "wither_skeleton_spawn_egg.png" -> Res.drawable.wither_skeleton_spawn_egg
        "wolf_spawn_egg.png" -> Res.drawable.wolf_spawn_egg
        "wooden_axe.png" -> Res.drawable.wooden_axe
        "wooden_hoe.png" -> Res.drawable.wooden_hoe
        "wooden_pickaxe.png" -> Res.drawable.wooden_pickaxe
        "wooden_shovel.png" -> Res.drawable.wooden_shovel
        "wooden_sword.png" -> Res.drawable.wooden_sword
        "writable_book.png" -> Res.drawable.writable_book
        "written_book.png" -> Res.drawable.written_book
        "yellow_banner.png" -> Res.drawable.yellow_banner
        "yellow_bed.png" -> Res.drawable.yellow_bed
        "yellow_carpet.png" -> Res.drawable.yellow_carpet
        "yellow_concrete.png" -> Res.drawable.yellow_concrete
        "yellow_concrete_powder.png" -> Res.drawable.yellow_concrete_powder
        "yellow_dye.png" -> Res.drawable.yellow_dye
        "yellow_glazed_terracotta.png" -> Res.drawable.yellow_glazed_terracotta
        "yellow_shulker_box.png" -> Res.drawable.yellow_shulker_box
        "yellow_stained_glass.png" -> Res.drawable.yellow_stained_glass
        "yellow_stained_glass_pane.png" -> Res.drawable.yellow_stained_glass_pane
        "yellow_terracotta.png" -> Res.drawable.yellow_terracotta
        "yellow_wool.png" -> Res.drawable.yellow_wool
        "zoglin_spawn_egg.png" -> Res.drawable.zoglin_spawn_egg
        "zombie_head.png" -> Res.drawable.zombie_head
        "zombie_horse_spawn_egg.png" -> Res.drawable.zombie_horse_spawn_egg
        "zombie_spawn_egg.png" -> Res.drawable.zombie_spawn_egg
        "zombie_villager_spawn_egg.png" -> Res.drawable.zombie_villager_spawn_egg
        "zombified_piglin_spawn_egg.png" -> Res.drawable.zombified_piglin_spawn_egg
        "fire_res.png" -> Res.drawable.fire_res
        "splash_fire_res.png" -> Res.drawable.splash_fire_res
        "iron_boots_ss1.png" -> Res.drawable.iron_boots_ss1
        "iron_boots_ss2.png" -> Res.drawable.iron_boots_ss2
        "iron_boots_ss3.png" -> Res.drawable.iron_boots_ss3
        "golden_boots_ss1.png" -> Res.drawable.golden_boots_ss1
        "golden_boots_ss2.png" -> Res.drawable.golden_boots_ss2
        "golden_boots_ss3.png" -> Res.drawable.golden_boots_ss3
        "golden_sword_l1.png" -> Res.drawable.golden_sword_l1
        "golden_sword_l2.png" -> Res.drawable.golden_sword_l2
        "golden_sword_l3.png" -> Res.drawable.golden_sword_l3
        "piglin_icon.png" -> Res.drawable.piglin_icon
        "force_perch_potion.png" -> Res.drawable.force_perch_potion
        "surface_blind_potion.png" -> Res.drawable.surface_blind_potion
        "kill_zombie_pigs_potion.png" -> Res.drawable.kill_zombie_pigs_potion
        else -> Res.drawable.missing_texture
    }
}